import React, { useEffect, useState } from "react";
import {
  FaBars,
  FaHome,
  FaSlidersH,
  FaShareAlt,
  FaCar,
  FaCity,
  FaUsers,
  FaBuilding,
  FaUserTie,
  FaUserShield,
  FaFileInvoiceDollar,
  FaCalendarCheck,
  FaMap,
  FaTags,
  FaThumbsUp,
  FaTruck,
  FaCheckCircle,
  FaComments,
  FaListAlt,
  FaUser,
  FaFacebookMessenger,
  FaClipboardList,
  FaCalculator,
  FaMapMarkedAlt,
  FaFileInvoice,
  FaEuroSign
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import "../assets/css/Sidebar.css";
import { useAuth } from '../context/AuthContext';
import { FaBoxesStacked, FaMoneyBill1Wave, FaTruckFast, FaUsersGear } from "react-icons/fa6";
import { TiThList } from "react-icons/ti";
import { RiAdvertisementFill, RiCloseLargeFill, RiPinDistanceFill } from "react-icons/ri";
import { SiExpertsexchange } from "react-icons/si";
import { Badge } from "react-bootstrap";
import { chatAPI } from "../api/apiClient";


export default function Sidebar({ isOpen, onToggleSidebar }) {
  const { t } = useTranslation();
  const { isSuperAdmin, checkSuperAdminStatus } = useAuth();
  const [customerMessagesCount, setCustomerMessagesCount] = useState(0);
  const [driverMessagesCount, setDriverMessagesCount] = useState(0);
  const [driverCompanyMessagesCount, setDriverCompanyMessagesCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 0,
  });
  

  // Fetch conversations with pagination and filter by User role
  const fetchUnreadCounts = async () => {
    try {
      setLoading(true);
      setError('');

      const response = await chatAPI.unreadCounts();

      if (response.success) {
        const data = response.data.data;
        console.log('Unread counts:', data);

        setCustomerMessagesCount(data.user_unread_count);
        setDriverMessagesCount(data.driver_unread_count);
        setDriverCompanyMessagesCount(data.driver_company_unread_count);
      } else {
        setError(response.message || t('failed_to_fetch_conversations'));
      }
    } catch (err) {
      console.error(err);
      setError(t('failed_to_fetch_conversations'));
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchUnreadCounts();
    checkSuperAdminStatus();
  }, []);

  return (
    <>
      <div className={`custom-sidebar ${isOpen ? "expanded" : "collapsed"}`}>
        <div className="sidebar-header d-flex justify-content-between align-items-center px-3 py-2">
          <span className="fw-bold text-truncate">
            {isOpen ? t("name-dashboard") : ""}
          </span>
          <button
            className="close-btn d-md-block"
            onClick={onToggleSidebar}
            aria-label="Toggle sidebar"
          >
            {isOpen ? <SiExpertsexchange /> : <FaBars />}
          </button>
        </div>

        <div className="sidebar-menu-scroll">
          <ul className="nav flex-column mt-3">
            <SidebarItem icon={<FaHome />} label={t("home")} to="/admin" isOpen={isOpen} end />
            <SidebarItem icon={<FaSlidersH />} label={t("settings")} to="/admin/settings" isOpen={isOpen} />
            <SidebarItem icon={<FaShareAlt />} label={t("social_media")} to="/admin/social-media" isOpen={isOpen} />
            {isSuperAdmin && (
              <>
                <SidebarItem icon={<FaTruckFast />} label={t("postal_areas")} to="/admin/postal-area" isOpen={isOpen} />
                <SidebarItem icon={<FaCar />} label={t("car_prices")} to="/admin/car-prices" isOpen={isOpen} />
                <SidebarItem icon={<RiPinDistanceFill />} label={t("car_multi_prices")} to="/admin/car-multi-prices" isOpen={isOpen} />
                <SidebarItem icon={<FaCity />} label={t("city_prices")} to="/admin/city-prices" isOpen={isOpen} />
                <SidebarItem icon={<FaEuroSign />} label={t("pricing_postal_codes")} to="/admin/pricing-postal-codes" isOpen={isOpen} />
                <SidebarItem icon={<FaMoneyBill1Wave />} label={t("Commissions")} to="/admin/commissions" isOpen={isOpen} />
              </>
            )}
            <SidebarItem icon={<RiAdvertisementFill />} label={t("advertisements.title")} to="/admin/advertisements" isOpen={isOpen} />
            {isSuperAdmin && (
              <>
                <SidebarItem icon={<FaTags />} label={t("coupons.title")} to="/admin/coupons" isOpen={isOpen} />
                <SidebarItem icon={<FaCalculator />} label={t("calculator_areas")} to="/admin/calculator-areas" isOpen={isOpen} />
                <SidebarItem icon={<FaUserShield />} label={t("Admins")} to="/admin/admin-company" isOpen={isOpen} />
              </>
            )}
            <SidebarItem icon={<FaUsers />} label={t("guests")} to="/admin/guests" isOpen={isOpen} />
            <SidebarItem icon={<FaUsers />} label={t("customers")} to="/admin/customers" isOpen={isOpen} />
            <SidebarItem icon={<FaUsersGear />} label={t("employees")} to="/admin/employees" isOpen={isOpen} />
            <SidebarItem icon={<FaUserTie />} label={t("drivers")} to="/admin/drivers" isOpen={isOpen} />
            <SidebarItem icon={<FaBuilding />} label={t("drivers_company")} to="/admin/drivers-company" isOpen={isOpen} />
            {/* <SidebarItem icon={<FaUser />} label={t("profile")} to="/admin/profile" isOpen={isOpen} /> */}
            <SidebarItem icon={<FaBoxesStacked />} label={t("special-bookings")} to="/admin/special-bookings" isOpen={isOpen} />
            <SidebarItem icon={<FaBoxesStacked />} label={t("bookings")} to="/admin/bookings" isOpen={isOpen} />
            <SidebarItem icon={<FaFileInvoice />} label={t("booking-invoices")} to="/admin/booking-invoices" isOpen={isOpen} />
            <SidebarItem icon={<TiThList />} label={t("BookingOrders")} to="/admin/booking-orders" isOpen={isOpen} />
            <SidebarItem icon={<FaBoxesStacked />} label={t("transports")} to="/admin/transports" isOpen={isOpen} />
            <SidebarItem icon={<FaFileInvoice />} label={t("transport-invoices")} to="/admin/transport-invoices" isOpen={isOpen} />
            <SidebarItem icon={<TiThList />} label={t("TransportOrders")} to="/admin/transport-orders" isOpen={isOpen} />

            <SidebarItem icon={<FaMapMarkedAlt />} label={t("admin-map")} to="/admin/admin-map" isOpen={isOpen} />

            {/* <SidebarItem icon={<FaMap />} label={t("map")} to="/admin/map" isOpen={isOpen} /> */}
            {/* <SidebarItem icon={<FaThumbsUp />} label={t("accepted_orders")} to="/admin/accepted-orders" isOpen={isOpen} />
            <SidebarItem icon={<FaTruck />} label={t("in_delivery")} to="/admin/in-delivery" isOpen={isOpen} />
            <SidebarItem icon={<FaCheckCircle />} label={t("completed_orders")} to="/admin/completed-orders" isOpen={isOpen} /> */}

            <div className="d-flex justify-content-between align-items-center">
              <SidebarItem icon={<FaFacebookMessenger />} label={t("client_chat")} to="/admin/client-list" isOpen={isOpen} />
              {customerMessagesCount > 0 && (
                <Badge bg="danger" pill className="flex-shrink-0">
                  !
                </Badge>
              )}
            </div>

            <div className="d-flex justify-content-between align-items-center">
              <SidebarItem icon={<FaFacebookMessenger />} label={t("driver_chat")} to="/admin/driver-list" isOpen={isOpen} />
              {driverMessagesCount > 0 && (
                <Badge bg="danger" pill className="flex-shrink-0">
                  !
                </Badge>
              )}
            </div>

            <div className="d-flex justify-content-between align-items-center">
              <SidebarItem icon={<FaFacebookMessenger />} label={t("driver_company_chat")} to="/admin/driver-company-list" isOpen={isOpen} />
              {driverCompanyMessagesCount > 0 && (
                <Badge bg="danger" pill className="flex-shrink-0">
                  !
                </Badge>
              )}
            </div>
            <SidebarItem icon={<FaListAlt />} label={t("logs")} to="/admin/logs" isOpen={isOpen} />
            <SidebarItem icon={<FaComments />} label={t("contact_messages")} to="/admin/contact" isOpen={isOpen} />
            <SidebarItem icon={<FaFileInvoiceDollar />} label={t("Rechnung")} to="/admin/invoices" isOpen={isOpen} />
          </ul>
        </div>
      </div>
    </>
  );
}

function SidebarItem({ icon, label, to, isOpen, end }) {
  return (
    <li className="nav-item col-11" title={!isOpen ? label : ""}>
      <NavLink
        to={to}
        end={end} 
        className={({ isActive }) =>
          `nav-link d-flex align-items-center ${isActive ? "active" : ""}`
        }
      >
        <span className="icon">{icon}</span>
        <span className={`link-text ${!isOpen ? "d-none" : ""}`}>{label}</span>
      </NavLink>
    </li>
  );
}
